import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category/movie",
    icon: "ri-movie-2-line",
    title: "电影频道",
    desc: "院线大片 · 独立佳作 · 类型齐全",
    count: "8 部精选",
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    title: "电视剧频道",
    desc: "热播剧集 · 口碑好剧 · 持续更新",
    count: "7 部精选",
  },
];

export default function CategoryEntry() {
  return (
    <section className="w-full px-4 md:px-8 -mt-10 md:-mt-14 relative z-20">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 max-w-4xl">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group flex items-center gap-4 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors duration-300 cursor-pointer"
          >
            <span className="w-14 h-14 md:w-16 md:h-16 shrink-0 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
              <i className={`${entry.icon} text-2xl md:text-3xl`}></i>
            </span>
            <div className="min-w-0">
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 group-hover:text-primary-600 transition-colors">
                {entry.title}
              </h3>
              <p className="mt-0.5 text-xs md:text-sm text-foreground-500 truncate">{entry.desc}</p>
              <p className="mt-1 text-xs text-accent-600 font-medium">{entry.count}</p>
            </div>
            <i className="ri-arrow-right-line ml-auto text-foreground-400 group-hover:text-primary-500 group-hover:translate-x-1 transition-all"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}